/*
 * File: 客户模块-客户管理-详情-一页纸-编辑文本
 */
<template>
    <el-dialog
        :visible="visible"
        title="编辑文本"
        width="50vw"
        custom-class="paper-edit-text-dialog"
        destroy-on-close
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="handleClose"
    >
        <div class="paper-edit-text-dialog-original">
            <span class="paper-edit-text-dialog-type">原文</span>
            <div v-html="originalText"></div>
        </div>
        <div class="paper-edit-text-dialog-original editor">
            <span class="paper-edit-text-dialog-type editor">修改</span>
            <Editor ref="editorRef" />
        </div>
        <span slot="footer">
            <el-button type="primary" size="small" @click="handleSave">保存</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { ref } from '@vue/composition-api';
import Editor from './editor.vue';

export default {
    components: { Editor },
    props: {},
    setup(props, setupContext) {
        const emit = setupContext.emit;
        const visible = ref(false);
        const originalText = ref('');

        const show = (val, initVal) => {
            visible.value = true;
            originalText.value = initVal;
            setupContext.root.$nextTick(() => {
                setupContext.refs.editorRef.setContent(val);
            });
        };
        const handleClose = () => {
            visible.value = false;
            originalText.value = '';
        };
        // 保存
        const handleSave = () => {
            const content = setupContext.refs.editorRef.getContentHtml();
            emit('confirm', content);
            handleClose();
        };
        return {
            visible,
            originalText,
            show,
            handleClose,
            handleSave
        };
    }
};
</script>

<style lang="less" scoped>
.paper-edit-text-dialog-original {
    height: 50vh;
    border: 1px solid rgba(0, 0, 0, .1);
    border-radius: 8px;
    padding: 38px 16px 16px;
    flex: 1;
    margin-right: 10px;
    position: relative;
    overflow: scroll;
    &.editor {
        background-color: #F2F3F5;
        margin: 0;
        margin-left: 10px;
    }
    .paper-edit-text-dialog-type {
        position: absolute;
        width: 76px;
        height: 28px;
        line-height: 28px;
        border-radius: 8px 0;
        top: 0;
        left: 0;
        text-align: center;
        color: #fff;
        background-color: #B2B2B2;
        font-size: 14px;
        &.editor {
            background-color: #4982F5;
        }
    }
}
</style>
<style lang="less">
.paper-edit-text-dialog {
    border-radius: 12px;
    .el-dialog__title {
        font-size: 16px;
        font-weight: 600;
    }
    .el-dialog__body {
        display: flex;
        color: #000;
        font-size: 16px;
    }
    .w-e-toolbar {
        display: none !important;
    }
    .w-e-toolbar, .w-e-text-container {
        background-color: #F2F3F5;
        border: none !important;
    }
    .w-e-text-container {
        height: 100% !important;
    }
    .w-e-text {
        padding: 0 !important;
    }
     .el-button {
        border-radius: 8px;
        padding: 10px 32px;
    }
}
</style>
